// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// NAVIGATION TOGGLE (Mobile + Points)

function toggleMenu(trigger, target) {
  var $trigger = $(trigger);
  var $target = $(target);
  var $body = $("body");
  var $header = $(".main-header");

  var isOpening = !$trigger.hasClass("cross");

  $(".cross").removeClass("cross");
  $(".main-nav-wrapper, .main-list-points").removeClass("open");
  $body.removeClass("overflow");
  $header.removeClass("open");

  if (isOpening) {
    $trigger.addClass("cross");
    $target.addClass("open");
    $header.addClass("open");
    $body.addClass("overflow");
  }
}

// MOBILE NAV
$("#btnMobile").on("click", function () {
  toggleMenu(this, ".main-nav-wrapper");
});

// POINTS NAV
$(".btn-list-points").on("click", function () {
  toggleMenu(this, ".main-list-points");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var nav = $('nav');
    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// CHARGEMENT EN AJAX DU CONTENT POI
jQuery(document).ready(function($) {
    var $poiWrapper = $(".wrapper-poi");
    var $poiLinks = $(".poiLink");
    var $poiDetail = $("#poi-detail");
    var $closeBtn = $poiDetail.find(".close-poi");
    var $poiContent = $poiDetail.find(".poi-content");

    var baseUrl = (window.location.hostname === 'localhost') ?
        'http://localhost:3000/mxapp' 
        : 'https://circuit.mxnamur.be';

    // Initialise la map Leaflet
    // ✅ PROTÉGÉ: vérifier que Leaflet existe
    function initMap(lat, lng, zoom) {
        if (typeof L === 'undefined') return;

        var mapContainer = document.getElementById('poi-map');
        if (!mapContainer) return;

        mapContainer.style.width = '100%';
        mapContainer.style.height = '600px';

        var map = L.map('poi-map').setView([lat, lng], zoom || 17);

        // Fond OpenStreetMap et non CARTO : cartocdn.com a fermé l'accès
        // anonyme à ses fonds de carte et renvoie désormais des tuiles
        // filigranées « API KEY REQUIRED » — en HTTP 200, donc sans la moindre
        // erreur JS pour le signaler.
        //
        // Même fournisseur que la carte de la page d'accueil (front-page.php),
        // pour que les deux cartes du site aient le même rendu.
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);

        var myIcon = L.divIcon({ className:'my-marker', iconSize:[30,30], iconAnchor:[15,15] });
        L.marker([lat, lng], { icon: myIcon }).addTo(map);

        setTimeout(function() { map.invalidateSize(); }, 50);

        window.leafletMap = map;
    }

    // Charge un POI via AJAX
    function loadPOI(poiID) {
        if (!poiID) return;

        $.ajax({
            url: baseUrl + '/wp-admin/admin-ajax.php',
            method: 'GET',
            data: { action: 'get_poi_content', id: poiID },
            success: function(response) {
                if (!response.success) {
                    $poiContent.html("<p>Impossible de charger ce POI : " + response.data + "</p>");
                    return;
                }

                var data = response.data;

                $poiContent.html(
                    '<section class="map" id="poi-map"></section>' +
                    '<header class="header-single-poi container"><h2>' + data.title + '</h2></header>' +
                    '<section class="single-poi-wrapper"><div class="content container">' + data.content + '</div></section>'
                );

                $poiDetail.removeClass("hidden");

                // ✅ PROTÉGÉ: initialise Slick SEULEMENT s'il existe
                if (typeof $.fn.slick !== 'undefined') {
                    if ($('.slick-main').length && $('.slick-nav').length) {
                        if ($('.slick-main').hasClass('slick-initialized')) {
                            $('.slick-main, .slick-nav').slick('unslick');
                        }

                        $('.slick-main').slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                            asNavFor: '.slick-nav',
                            adaptiveHeight: true
                        });

                        $('.slick-nav').slick({
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            asNavFor: '.slick-main',
                            focusOnSelect: true,
                            arrows: false,
                            centerMode: false
                        });
                    }
                }

                // Initialise la map si coordonnées ACF disponibles
                if (data.acf && data.acf.poi_geocalisation) {
                    var markers = data.acf.poi_geocalisation.markers;
                    if (markers && markers.length) {
                        var marker = markers[0];
                        var latExact = parseFloat(marker.lat);
                        var lngExact = parseFloat(marker.lng);
                        var zoom = parseInt(data.acf.poi_geocalisation.zoom) || 17;

                        initMap(latExact, lngExact, zoom);
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                $poiContent.html("<p>Impossible de charger ce POI : " + errorThrown + "</p>");
            }
        });
    }

    // ID depuis l'URL
    var urlParams = new URLSearchParams(window.location.search);
    var poiIDFromURL = urlParams.get('id');
    if (poiIDFromURL) loadPOI(poiIDFromURL);

    // Clic sur liens POI
    $poiLinks.on("click", function(e) {
        e.preventDefault();
        var link = $(this).attr('href');
        var poiIDFromLink = new URLSearchParams(link.split('?')[1]).get('id');
        loadPOI(poiIDFromLink);
    });

    // Bouton fermeture
    $closeBtn.on("click", function() {
        $poiDetail.addClass("hidden");
        $poiDetail.find("iframe").each(function() {
            $(this).attr("src", $(this).attr("src"));
        });
    });
});

// ###########################################################################
// SLICK - slideshow & slider
// ✅ PROTÉGÉ: initialiser SEULEMENT si Slick existe
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.poi-grid > .content').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      infinite: true,
      arrows: false,
      focusOnSelect: true,
      swipeToSlide: true,
      touchThreshold: 10,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        }
      ]
    });

    $('.slick-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.slick-nav',
      adaptiveHeight: true
    });

    $('.slick-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slick-main',
      focusOnSelect: true,
      arrows: false,
      centerMode: false
    });

  });
}

// ###########################################################################
// TOUCH HANDLING FOR POI GRID
$('.poi-grid > .content').on('touchstart', 'a', function(e) {
  $(this).data('touchStartX', e.originalEvent.touches[0].clientX);
});

$('.poi-grid > .content').on('touchend', 'a', function(e) {
  var startX = $(this).data('touchStartX');
  var endX = e.originalEvent.changedTouches[0].clientX;
  if (Math.abs(startX - endX) < 10) {
    $(this).trigger('click');
  }
});